import {
  Button,
  Center,
  Modal,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { ReactElement } from "react";
import { IConfirmStorageRemovalProps } from "./types";
import IconDWH from "@common/components/icons/IconDWH";

export function ConfirmStorageRemovalModal({
  opened,
  onClose,
}: IConfirmStorageRemovalProps): ReactElement {
  const theme = useMantineTheme();

  return (
    <Modal
      data-testid="ConfirmStorageRemoval-modal"
      centered
      onClose={() => onClose()}
      withCloseButton={false}
      opened={opened}
      overflow="inside"
      padding={2 * theme.spacing.md}
      size="md"
    >
      <Stack spacing="xl" ta="center">
        <Center>
          <IconDWH />
        </Center>

        <Text fz="sm" ta="center">
          To upload CSVs and spreadsheets to your Metabase, you&apos;ll either
          need to connect to a database that supports uploads, or add a storage
          plan.
        </Text>

        <Stack spacing="sm" w="auto">
          <Button w="auto" onClick={() => onClose(false)}>
            Keep storage
          </Button>
          <Button variant="outline" w="auto" onClick={() => onClose(true)}>
            Remove storage
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}
